import { attach, type Effect, type Store } from 'effector'

import { $initialized, getLoginStatusFx, loginFx } from './model'

export type FacebookSDK = {
    initialized: Store<boolean>
    login: Effect<void, facebook.StatusResponse, facebook.StatusResponse>
    getLoginStatus: Effect<void, facebook.StatusResponse, facebook.StatusResponse>
}

export function createFacebookSDK({ scope }: { scope?: string[] } = {}): FacebookSDK {
    return {
        initialized: $initialized,
        login: attach({ effect: loginFx, mapParams: () => ({ scope }) }),
        getLoginStatus: attach({ effect: getLoginStatusFx }),
    }
}
